import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWRMutation from "swr/mutation";

const deleteTasks = async (ids) => {
  return jwtAxios.delete(URL_API.CMS_TASKS.DELETE_TASK, { data: { ids } });
};

const useDeleteTasks = () => {
  const fetcher = (url, { arg }) => deleteTasks(arg);
  return useSWRMutation(URL_API.CMS_TASKS.DELETE_TASK, fetcher);
};

export default useDeleteTasks;
